import { Envinronments } from '@/sidebar/domain/constants';

export const isEnabledByEnvAndSource = (
  source: string,
  envs: Array<Envinronments>,
  authorizedSources: string[],
  currentEnvironment: Envinronments,
) => envs.includes(currentEnvironment) && authorizedSources.includes(source);
